import { url, setTip, bi } from './gb'
import Login from './login'
import { Role, userInfo, roleList, isRoleBind } from './role'
import fullPage from './fullpage'

let lotteryResult = {
    type: -1,
    surplus: 0
  },
  lotteryRecord,
  giftList,
  lNum = -1

const Lottery = {
  // 获取初始化抽奖列表
  api_lotteryInit: () => {
    $.ajax({
      url: url.lotteryGift,
      dataType: 'jsonp'
    }).done(d => {
      if (d.success) {
        giftList = d.data
        Lottery.UI_lotteryInit()
      } else {
        setTip(d.messages)
      }
    })
  },
  // 抽奖
  api_lottery: () => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: url.lottery,
        dataType: 'jsonp'
      }).done(d => {
        if (d.success) {
          lotteryResult = d.data
          Lottery.UI_lotteryResult()
          Lottery.UI_lotterySurplus(lotteryResult.surplus)
          resolve()
        } else {
          lotteryResult = {
            type: -1,
            surplus: userInfo.surplus
          }
          Lottery.UI_lotterySurplus(lotteryResult.surplus)
          setTip(d.messages)
          reject(d.messages)
        }
      })
    })
  },
  // 获取中奖记录
  api_lotteryRecord: () => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: url.lotteryRecord,
        dataType: 'jsonp'
      }).done(d => {
        if (d.success) {
          lotteryRecord = d.data.dataSet
          resolve()
          Lottery.UI_lotteryRecord()
        } else {
          setTip(d.messages)
          reject(d.messages)
        }
      })
    })
  },
  // 初始化抽奖奖品列表
  UI_lotteryInit: () => {
    let html = ''
    giftList.forEach(ele => {
      html += `<div class="item" data-gift-type="${
        ele.type
      }"><figure class="img"><img src="${ele.img}"></figure><div class="name">${
        ele.gift
      }</div></div>`
    })
    $('[data-lottery-gift]').prepend(html)
  },
  //抽奖动画
  UI_lotteryAni: fn => {
    const wrap = $('[data-lottery-gift]'),
      item = $('[data-lottery-gift] .item'),
      len = item.length
    let timer = null,
      current = wrap.find('.active').index(),
      circle = 1, // 至少要转几圈
      iSpeed = 300,
      count = 0, // 转了多少次
      iLast = 2 // 最后一次转圈圈

    ;(function run() {
      // 前3个加速
      if (count > Math.floor(circle / 2)) {
        iSpeed = 100
      }

      // 后3个减速
      if (iLast < Math.floor(circle / 2)) {
        iSpeed = 300
      }
      current++
      count++
      if (current >= len) {
        current = 0
        circle--
      }
      item
        .removeClass('active')
        .eq(current)
        .addClass('active')

      timer = setTimeout(run, iSpeed)

      // 得到结果
      if (lNum !== -1 && circle <= 0 && current == lNum) {
        iLast--
        if (iLast == 0) {
          clearTimeout(timer)
          timer = null
          fn()
        }
      }
    })()
  },
  UI_lotterySurplus: num => {
    lotteryResult.surplus = num
    $('[data-lottery-count]').text(num)

    if (num === 0 && TlPassport.isLoggedIn()) {
      $('[data-btn-lottery]').addClass('disabled')
    } else {
      $('[data-btn-lottery]').removeClass('disabled')
    }
  },
  // 渲染抽奖结果
  UI_lotteryResult: () => {
    const lr = giftList.filter(ele => {
      return ele.type == lotteryResult.type
    })[0]
    $('[data-dialog-lottery-result] .lottery-result').html(
      `<figure class="pic"><img src="${lr.img}"></figure><p class="txt">${
        lr.gift
      }</p>`
    )
  },
  // 渲染中奖记录
  UI_lotteryRecord: () => {
    let html = ''
    if (lotteryRecord.length < 1) {
      $('[data-lottery-record-list]').html('<li>暂无中奖记录</li>')
      return
    }
    lotteryRecord.forEach(ele => {
      const time = new Date(parseInt(ele.date + '000'))
      html += `<li><span class="date">${formatDateTime(
        time
      )}</span><span class="name">${ele.gift}</span></li>`
    })
    $('[data-lottery-record-list]').html(html)
  }
}

function formatDateTime(date) {
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = date.getDate()
  d = d < 10 ? '0' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  minute = minute < 10 ? '0' + minute : minute
  let second = date.getSeconds()
  second = second < 10 ? '0' + second : second
  return y + '.' + m + '.' + d + ' ' + h + ':' + minute + ':' + second
}

$(document).on('click', '[data-btn-lottery]', async e => {
  await Login.checkLogin()

  Role.trigger_submitTarget($(e.target))

  if (lotteryResult.surplus === 0) {
    if (roleList.length > 0 && isRoleBind) {
      setTip('抽奖次数已用完')
    }
    return
  }
  await Lottery.api_lottery()

  lNum = lotteryResult.type - 1

  $('.btn-lottery-mask').show()

  Lottery.UI_lotteryAni(function() {
    $('.btn-lottery-mask').hide()
    $('[data-dialog-lottery-result]').show()
    fullPage.lockScroll()
  })
  bi('按钮-抽奖')
})
$('[data-lottery-record]').click(async () => {
  await Login.checkLogin()
  if (roleList.length > 0 && isRoleBind) {
    await Lottery.api_lotteryRecord()
    $('[data-dialog-lottery-record]').show()
  } else {
    Role.state_roleUnbind()
  }
  bi('按钮-我的中奖记录')
  fullPage.lockScroll()
})

export default Lottery
